export default __webpack_public_path__ + "static/media/signature.f24502cb.png";